import * as React from "react"

const ThemeToggle = () => {
  const [theme, setTheme] = React.useState(null)

  React.useEffect(() => {
    // Read current theme from document (set by the inline script)
    const current = document.documentElement.getAttribute("data-theme") || "light"
    setTheme(current)
  }, [])

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark"
    setTheme(next)
    document.documentElement.setAttribute("data-theme", next)
    try {
      localStorage.setItem("jsbit-theme", next)
    } catch (e) {}
  }

  // Don't render on SSR (theme === null)
  if (theme === null) return <span style={{ width: 32, display: "inline-block" }} />

  return (
    <button
      onClick={toggle}
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      title={theme === "dark" ? "Light mode" : "Dark mode"}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "1.2rem",
        padding: "4px 8px",
        borderRadius: "6px",
        lineHeight: 1,
        color: "inherit",
        opacity: 0.75,
        transition: "opacity 0.15s ease",
      }}
      onMouseEnter={e => (e.currentTarget.style.opacity = "1")}
      onMouseLeave={e => (e.currentTarget.style.opacity = "0.75")}
    >
      {theme === "dark" ? "☀️" : "🌙"}
    </button>
  )
}

export default ThemeToggle
